import {
    ADD_OEM_REQUEST,
    ADD_OEM_RESULT,
    ADD_OEM_OPEN_MODAL,
    ADD_OEM_CLOSE_MODAL,
    ADD_OEM_GET_INTEGRATIONS_REQUEST,
    ADD_OEM_GET_INTEGRATIONS_RESULT,
    ADD_OEM_SET_INTEGRATIONS,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    integrations: [],
    companyIntegrationId: null,
    companyOems: [],
    fleetId: null
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case ADD_OEM_REQUEST:
            return { ...state, loading: true }

        case ADD_OEM_RESULT:
            return { ...state, loading: false, result: action.payload }

        case ADD_OEM_OPEN_MODAL:
            return { ...state, openModal: true, companyIntegrationId: action.payload.companyIntegrationId, companyOems: action.payload.companyOems, fleetId: action.payload.fleetId }

        case ADD_OEM_CLOSE_MODAL:
            return { ...state, openModal: false,  }

        case ADD_OEM_GET_INTEGRATIONS_REQUEST:
            return { ...state, loading: true }

        case ADD_OEM_GET_INTEGRATIONS_RESULT:
            return { ...state, loading: false, integrations: action.payload.items }

        case ADD_OEM_SET_INTEGRATIONS:
            return { ...state, devices: action.payload }


        case CLEAR_REDUX:
            return ["", "ADD_OEM"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};